'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddThis = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(AddThis, _Component);

    function AddThis() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AddThis);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddThis.__proto__ || (0, _getPrototypeOf2.default)(AddThis)).call.apply(_ref, [this].concat(args))), _this), _this.initializeAddThis = function () {
            /* eslint-disable no-undef */
            if (typeof addthis !== 'undefined' && addthis.init) {
                addthis.init();
                addthis.toolbox('.share_button_wrapper');
            } else {
                _this.shareWrapper.style.display = 'none';
            }
            /* eslint-enable no-undef */
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AddThis, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initializeAddThis();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'itemTitle', 'itemUrl']);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.itemTitle !== prevProps.itemTitle) {
                this.initializeAddThis();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                itemTitle = _props.itemTitle,
                itemUrl = _props.itemUrl;


            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(share) {
                        _this2.shareWrapper = share;
                    },
                    className: 'share_button_wrapper ' + (className || ''),
                    'data-addthis-title': itemTitle,
                    'data-addthis-url': itemUrl
                },
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_email share-button'
                }),
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_pinterest_share share-button'
                }),
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_facebook share-button'
                }),
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_twitter share-button'
                })
            );
        }
    }]);
    return AddThis;
}(_react.Component), _class.defaultProps = {
    className: '',
    itemTitle: '',
    itemUrl: ''
}, _temp2);
exports.default = AddThis;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddThis/AddThis.js
// module id = QJRV
// module chunks = 57